<template>
  <footer>
    <div class="footer-links no-print">
      <router-link to="/about/legal/#termsOfUse">Terms</router-link>
      <router-link to="/about/legal/#privacy">Privacy</router-link>
      <router-link to="/about/contact">Contact</router-link>
    </div>
    <img
      height="1"
      width="1"
      style="display:none;"
      alt=""
      src="https://px.ads.linkedin.com/collect/?pid=2807145&fmt=gif"
    />
  </footer>
</template>

<script>
export default {
  name: 'app-footer-minimal',
}
</script>

<style lang="scss" scoped>
footer {
  background: #0e1b30;
  padding: 20px 40px 25px;
  border-top: 1px solid #e4e4e4;
  font-size: 12px;
}
.footer-links {
  text-align: center;
  a {
    color: #fff;
    padding-right: $padding-xl;
    text-transform: uppercase;
    &:hover {
      color: darken(#fff, 10%);
    }
  }
}
</style>
